import { AxiosRequestConfig } from 'axios';
import axios from './axiosSetup3';
import { Currency, Language } from '../types/ref';

interface Option {
  value: string | number;
  label: string;
}

const getCurrency = async (): Promise<Option[]> => {
    const res = await axios.get<Currency[]>(`/currency`,{
        headers: {
            'Accept-Profile': 'billing' // schema
        }
    });
    return res.data.map(rec => { return {
        value: rec.name,
        label: rec.name,
    }});
};

const getLanguage = async (): Promise<Option[]> => {
    const res = await axios.get<Language[]>(`/language`, {
        headers: {
            'Accept-Profile': 'public' // schema
        }
    });
    return res.data.map(rec => { return {
        value: rec.lang,
        label: rec.language,
    }});
};

export const api = {
    getCurrency,
    getLanguage,
};